import { ILLGenericKeys} from './index';

export class ILLPackageMarketing {
 marketingStatus: ILLGenericKeys;
 startDate: Date;
 endDate: Date;
}
